export default __webpack_public_path__ + "static/media/dpla-logo.e1172100.png";